import { ComponentsManager } from '../core/smpl-components'

// -- Components ---------------------------------------------------------- //
import ComponentBody from '../components/body'
import ComponentAnalytics from '../components/analytics'
import ComponentAhoyIsland from '../components/ahoy-island'
import ComponentMainNav from '../components/main-nav'
import ComponentFaq from '../components/faq'
import ComponentScallop from '../components/scallop'
import ComponentStatReels from '../components/stat-reels'
import ComponentLocationsSlider from '../components/locations-slider'
import ComponentProgramSlider from '../components/program-slider'
import ComponentHighlightsSlider from '../components/highlights-slider'
import ComponentContentGrid from '../components/content-grid'
import ComponentCoupon from '../components/coupon'
import ComponentTicker from '../components/ticker'
import ComponentScrollReveal from '../components/scroll-reveal'
import ComponentScrollParallax from '../components/scroll-parallax'
import ComponentImageParallax from '../components/image-parallax'
import ComponentHomeIntro from '../components/home-intro'

// import ComponentExpandingPanels from '../components/expanding-panels'
// import ComponentCardsSlider from '../components/cards-slider'
// import ComponentStackViewer from '../components/stack-viewer'
// import ComponentFeatureHotspots from '../components/feature-hotspots'
// import ComponentConfiguratorIsland from '../components/configurator-island'
// import ComponentMainNav from '../components/main-nav'
// import ComponentMarketoForm from '../components/marketo-form'
// import ComponentHomeIntro from '../components/home-intro'
// import ComponentMediaPlayInView from '../components/media-play-in-view'
// import ComponentFaq from '../components/faq'
// import ComponentMediaColumns from '../components/media-columns'
// import ComponentScrollReveal from '../components/scroll-reveal'
// import ComponentSectionIntroReveal from '../components/section-intro-reveal'
// import ComponentLandingHero from '../components/landing-hero'

// import ComponentAccordion from '../components/accordion'
// import ComponentArticleNavigator from '../components/article-navigator'
// import ComponentProfileAccordion from '../components/profile-accordion'
// import ComponentMediaSlider from '../components/media-slider'
// import ComponentServicesPreview from '../components/services-preview'
// import ComponentQuoteSlider from '../components/quote-slider'
// import ComponentProfileViewer from '../components/profile-viewer'
// import ComponentFooter from '../components/footer'
// import ComponentForm from '../components/form'
// import ComponentTextFill from '../components/text-fill'
// import ComponentLogoCarousel from '../compon`ents/logo-carousel'
// import ComponentMainNav from '../components/main-nav'
// import ComponentStoriesGrid from '../components/stories-grid'
// import ComponentStickyNewsList from '../components/sticky-news-list'
// import ComponentReadTime from '../components/read-time'
// import ComponentHomeAboutIntro from '../components/home-about-intro'
// import ComponentScrollReveal from '../components/scroll-reveal'
// import ComponentScrollParallax from '../components/scroll-parallax'
// ------------------------------------------------------------------------- //
// import { componentRegistry } from '../config/components-registry'

const componentRegistry = [
	{
		selector: 'body',
		name: 'body',
		loader: () => ComponentBody,
	},
	{
		selector: 'body',
		name: 'analytics',
		loader: () => ComponentAnalytics,
	},
	{
		selector: '.js-ahoy-island',
		name: 'ahoy-island',
		loader: () => ComponentAhoyIsland,
	},
	{
		selector: '.js-main-nav',
		name: 'main-nav',
		loader: () => ComponentMainNav,
	},
	{
		selector: '.js-faq',
		name: 'faq',
		loader: () => ComponentFaq,
	},
	{
		selector: '.js-content-grid',
		name: 'content-grid',
		loader: () => ComponentContentGrid,
	},
	{
		selector: 'body',
		name: 'scallop',
		loader: () => ComponentScallop,
	},
	{
		selector: '.js-stat-reels',
		name: 'stat-reels',
		loader: () => ComponentStatReels,
	},
	{
		selector: '.js-locations-slider',
		name: 'locations-slider',
		loader: () => ComponentLocationsSlider,
	},
	{
		selector: '.js-program-slider',
		name: 'program-slider',
		loader: () => ComponentProgramSlider,
	},
	{
		selector: '.js-highlights-slider',
		name: 'highlights-slider',
		loader: () => ComponentHighlightsSlider,
	},
	{
		selector: '.js-coupon',
		name: 'coupon',
		loader: () => ComponentCoupon,
	},
	{
		selector: '.js-ticker',
		name: 'ticker',
		loader: () => ComponentTicker,
	},
	{
		selector: 'body',
		name: 'scroll-parallax',
		loader: () => ComponentScrollParallax,
	},
	{
		selector: 'body',
		name: 'scroll-reveal',
		loader: () => ComponentScrollReveal,
	},
	{
		selector: '.js-image-parallax',
		name: 'image-parallax',
		loader: () => ComponentImageParallax,
	},
	{
		selector: '.js-home-intro',
		name: 'home-intro',
		loader: () => ComponentHomeIntro,
	},
	// {
	// 	selector: '.js-expanding-panels',
	// 	name: 'expanding-panels',
	// 	loader: () => ComponentExpandingPanels,
	// },
	// {
	// 	selector: '.js-cards-slider',
	// 	name: 'cards-slider',
	// 	loader: () => ComponentCardsSlider,
	// },
	// {
	// 	selector: '.js-stack-viewer',
	// 	name: 'stack-viewer',
	// 	loader: () => ComponentStackViewer,
	// },
	// {
	// 	selector: '.js-feature-hotspots',
	// 	name: 'feature-hotspots',
	// 	loader: () => ComponentFeatureHotspots,
	// },
	// {
	// 	selector: '.js-configurator-island',
	// 	name: 'configurator-island',
	// 	loader: () => ComponentConfiguratorIsland,
	// },
	// {
	// 	selector: '.js-main-nav',
	// 	name: 'main-nav',
	// 	loader: () => ComponentMainNav,
	// },
	// {
	// 	selector: '.js-marketo-form',
	// 	name: 'marketo-form',
	// 	loader: () => ComponentMarketoForm,
	// },
	// {
	// 	selector: '.js-home-intro',
	// 	name: 'home-intro',
	// 	loader: () => ComponentHomeIntro,
	// },
	// {
	// 	selector: '.js-media-play-in-view',
	// 	name: 'media-play-in-view',
	// 	loader: () => ComponentMediaPlayInView,
	// },
	// {
	// 	selector: '.js-faq',
	// 	name: 'faq',
	// 	loader: () => ComponentFaq,
	// },
	// {
	// 	selector: '.js-media-columns',
	// 	name: 'media-columns',
	// 	loader: () => ComponentMediaColumns,
	// },
	// {
	// 	selector: 'body',
	// 	name: 'scroll-reveal',
	// 	loader: () => ComponentScrollReveal,
	// },
	// {
	// 	selector: '.js-section-intro-reveal',
	// 	name: 'section-intro-reveal',
	// 	loader: () => ComponentSectionIntroReveal,
	// },
	// {
	// 	selector: '.js-landing-hero',
	// 	name: 'landing-hero',
	// 	loader: () => ComponentLandingHero,
	// },
]

// ...existing code...
export const initComponents = (ctx) => {
	ComponentsManager.setup({
		debug: true,
		components: componentRegistry,
		eventBus: ctx.eventBus,
	})

	// window.ComponentsManager = ComponentsManager
	ctx.componentsManager = ComponentsManager

	//
	// document.addEventListener(
	//     'DOMContentLoaded',
	//     () => {
	//         manager.init()
	//     },
	//     { once: true }
	// )

	return ComponentsManager
}
